const FUNCTIONS_ENDPOINT= "https://us-central1-wedding-db244.cloudfunctions.net";

export function generateString(characters: string, length: number): string {
  let result = `${Math.floor(Math.random() * length)}`;
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export const castVote = async (endPoint : string, voteResult: any) => {
  const reqBody = {
    endPoint,
    voteResult
  }
  const response = await fetch(`${FUNCTIONS_ENDPOINT}/castVote`, {
    method: "POST",
    body: JSON.stringify(reqBody),
    mode:"no-cors",
    headers: {
      "Content-Type": "application/json", 
    },
  });

  return response;
}

export const increaseVoteCount = async (endPoint : string, voteFor: any) => {
  const reqBody = {
    endPoint,
    voteFor
  }
  const response = await fetch(`${FUNCTIONS_ENDPOINT}/increaseVoteCount`, {
    method: "POST",
    body: JSON.stringify(reqBody),
    mode:"no-cors",
    headers: {
      "Content-Type": "application/json", 
    },
  });

  return response;
}

export const setComment = async (
   key: string,
   text: string,
   name: string, 
   pwd:string, 
   likes: number, 
   timestamp : number) => {

  const reqBody = {
    key,
    text,
    name,
    pwd,
    likes,
    timestamp
  }

  const response = await fetch(`${FUNCTIONS_ENDPOINT}/writeComment`, {
    method: "POST",
    body: JSON.stringify(reqBody),
    mode:"no-cors",
    headers: {
      "Content-Type": "application/json", 
    },
  });

  return response;
}

export const removeComment = async (key: string, pwd: string) => {
  const reqBody = {
    key,
    pwd
  }

  const response = await fetch(`${FUNCTIONS_ENDPOINT}/deleteComment`, {
    method: "POST",
    body: JSON.stringify(reqBody),
    mode:"no-cors",
    headers: {
      "Content-Type": "application/json", 
    },
  });

  return response;
}


export const setImageLikes = async (id: string, src: string, likes: string) => {
  const reqBody = {
    id,
    src,
    likes
  }

  const response = await fetch(`${FUNCTIONS_ENDPOINT}/setImageLikes`, {
    method: "POST",
    body: JSON.stringify(reqBody),
    mode:"no-cors",
    headers: {
      "Content-Type": "application/json", 
    },
  });

  return response;
}

export const setVisitorCount = async (count: number) =>{
  const reqBody = {
    count
  }

  const response = await fetch(`${FUNCTIONS_ENDPOINT}/setVisitorCount`, {
    method: "POST",
    body: JSON.stringify(reqBody),
    mode:"no-cors",
    headers: {
      "Content-Type": "application/json", 
    },
  });

  return response;
  
}

export const setTodayVisitCount = async (count: number, today: string) =>{
  const reqBody = {
    count,
    today
  }

  const response = await fetch(`${FUNCTIONS_ENDPOINT}/setTodayVisitCount`, {
    method: "POST",
    body: JSON.stringify(reqBody),
    mode:"no-cors",
    headers: {
      "Content-Type": "application/json", 
    },
  });

  return response;
  
}




